module.exports = __webpack_public_path__ + "img/bigsee.14affbea.png";